import React from "react"
import { Box } from "@mui/material"
import {
	Edit,
	required,
	SimpleForm,
	TextInput,
	useNotify,
	useRedirect,
	useRefresh
} from "react-admin"

import sx from "utils/sx"

const EmailAddressEdit = () => {
	const notify = useNotify()
	const refresh = useRefresh()
	const redirect = useRedirect()

	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	const onSuccess = (data: any) => {
		notify(
			"resources.email_addresses.notifications.edit",
			{
				type: "info",
				messageArgs: { name: data.name }
			}
		)
		redirect("/email-addresses")
		refresh()
	}

	return (
		<Edit
			mutationOptions={{ onSuccess }}
			mutationMode="pessimistic"
			title="resources.email_addresses.edit"
		>
			<SimpleForm>
				<Box sx={sx.prose}>
					<TextInput
						source="name"
						label="resources.email_addresses.fields.name"
						validate={required()}
						fullWidth
					/>
					<TextInput
						label="resources.email_addresses.fields.email"
						source="email"
						type="email"
						validate={required()}
						fullWidth
					/>
				</Box>
			</SimpleForm>
		</Edit>
	)
}


export default EmailAddressEdit
